import React, { FC } from "react"
import { SpinnerProps } from "./Spinner.types"

const Spinner: FC<SpinnerProps> = ({
    inverted,
    className,
    ...props
}: SpinnerProps) => {
    let klass = `zb-loader ${className || ""}`
    if (inverted) klass += " zb-loader-inverted"

    return <span className={klass} {...props} />
}

export default Spinner
